import {
  INSTRUMENTAL_RECOMMENDED_THRESHOLD,
  REVERB_RECOMMENDED_THRESHOLD,
} from "@/constants/audioQuality";
import { AudioQualityCheck } from "@/types/defs/audioQuality/audioQualityCheck";

// Model training uses the same instrument/reverb thresholds as conversion, but without conversion's instrument→reverb coupling or auto-apply tiers — each effect is flagged independently for a warning badge.
export const getModelEffectsDetection = (
  audioQualityCheck: AudioQualityCheck | null
): { hasInstrumentalDetected: boolean; hasReverbDetected: boolean } => {
  if (audioQualityCheck === null) {
    return { hasInstrumentalDetected: false, hasReverbDetected: false };
  }
  return {
    hasInstrumentalDetected:
      audioQualityCheck.instrumentRatio >= INSTRUMENTAL_RECOMMENDED_THRESHOLD,
    hasReverbDetected:
      audioQualityCheck.reverbRatio >= REVERB_RECOMMENDED_THRESHOLD,
  };
};
